<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">

<body>
    <header>
        <nav class="container">
            <div class="logo"><img [src]="environment.assets.logo"/></div>
            <ul class="nav-links">
                <li><a href="#home">Home</a></li>
                <li><a href="#features">Features</a></li>
                <li><a href="#team">Team</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>

            <div class="nav-buttons">
                <a [routerLink]='"login"' class="cta-button-outline">Login</a>
                <a [routerLink]='"register"' class="cta-button">Register Now</a>
            </div>
        </nav>
    </header>

    <section id="home" class="hero">
        <div class="container">
            <div class="hero-content">
                <div class="hero-badge">Inspiring Future Programmers</div>

                <div class="hero-text">
                    <h1>Master <span>IGCSE Computer Science</span> with CSTeam</h1>
                    <p>Join over 100+ dedicated educators and thousands of successful students across Egypt and MENA.
                        Experience cutting-edge learning with our revolutionary Pseudocode Translator.</p>
                </div>

                <div class="hero-buttons">
                    <a href="#features" class="cta-button">Explore Features</a>
                    <a href="#team" class="cta-button"
                        style="background: rgba(255,255,255,0.2); border: 2px solid white; color: white; backdrop-filter: blur(10px);">Meet
                        Our Team</a>
                </div>

                <div class="hero-visual">
                    <div class="code-card">
                        <span class="code-card-icon">💻</span>
                        <h3>Pseudocode Translator</h3>
                        <p>Transform pseudocode into real programming languages instantly</p>
                    </div>
                    <div class="code-card">
                        <span class="code-card-icon">🎯</span>
                        <h3>Personalized Learning</h3>
                        <p>Adaptive paths tailored to each student's progress and needs</p>
                    </div>
                    <div class="code-card">
                        <span class="code-card-icon">🏆</span>
                        <h3>IGCSE Excellence</h3>
                        <p>Proven success in IGCSE Computer Science 0984 examinations</p>
                    </div>
                </div>

                <div class="hero-stats">
                    <div class="hero-stat">
                        <h4>9+</h4>
                        <p>Years</p>
                    </div>
                    <div class="hero-stat">
                        <h4>100+</h4>
                        <p>Educators</p>
                    </div>
                    <div class="hero-stat">
                        <h4>25+</h4>
                        <p>Schools</p>
                    </div>
                    <div class="hero-stat">
                        <h4>10,000+</h4>
                        <p>Students</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section id="features" class="features">
        <div class="container">
            <h2 class="section-title">Why Choose CSTeam?</h2>
            <div class="features-grid">
                <div class="feature-card fade-in">
                    <div class="feature-icon">🏫</div>
                    <h3>25+ Partner Schools</h3>
                    <p>Trusted by over 25 schools across Egypt and MENA region, with a proven track record of student
                        success.</p>
                </div>
                <div class="feature-card fade-in">
                    <div class="feature-icon">🎯</div>
                    <h3>Personalized Learning & Support</h3>
                    <p>We identify each student's weak points and provide targeted support with customized learning
                        paths, ensuring no student is left behind in their programming journey.</p>
                </div>
                <div class="feature-card fade-in">
                    <div class="feature-icon">💻</div>
                    <h3>Interactive Learning Platform</h3>
                    <p>Code directly in your browser with our integrated development environment, no installations
                        required.</p>
                </div>
            </div>
        </div>
    </section>

    <!-- <section class="stats">
        <div class="container">
            <div class="stats-grid">
                <div class="stat-item">
                    <h3>9</h3>
                    <p>Years of Excellence</p>
                </div>
                <div class="stat-item">
                    <h3>100+</h3>
                    <p>Expert Educators</p>
                </div>
                <div class="stat-item">
                    <h3>25+</h3>
                    <p>Partner Schools</p>
                </div>
                <div class="stat-item">
                    <h3>1000+</h3>
                    <p>Successful Students</p>
                </div>
            </div>
        </div>
    </section> -->

    <section id="team" class="team">
        <div class="container">
            <h2 class="section-title">Meet Our Founding Team</h2>
            <div class="team-grid">
                <div class="team-card fade-in">
                    <div class="team-avatar">OE</div>
                    <h3>Eng. Omar El Safty</h3>
                    <div class="role">Founder & Lead Educator</div>
                    <p>Computer Science graduate from The American University in Cairo. Founded CSTeam in 2016 with a
                        vision to revolutionize computer science education in the MENA region.</p>
                </div>
                <div class="team-card fade-in">
                    <div class="team-avatar">IB</div>
                    <h3>Eng. Ismail El Badawy</h3>
                    <div class="role">Technology Director</div>
                    <p>Computer Engineering graduate from Cairo University (2020). Joined CSTeam in 2017 and leads the
                        development of our innovative tech platforms and educational tools.</p>
                </div>
                <div class="team-card fade-in">
                    <div class="team-avatar">AH</div>
                    <h3>Eng. Amr Hoballah</h3>
                    <div class="role">Senior Educator</div>
                    <p>Graduate from German University in Cairo. Joined CSTeam in 2018 and brings international
                        educational standards to our curriculum and teaching methodologies.</p>
                </div>
            </div>
        </div>
    </section>

    <section id="contact" class="cta-section">
        <div class="container">
            <h2 class="section-title">Ready to Start Your Journey?</h2>
            <p style="font-size: 1.2rem; color: #666; margin-bottom: 2rem;">Join thousands of students who have mastered
                computer science with CSTeam</p>

            <div class="app-buttons">
                <div class="store-badges">
                    <div>
                        <a target="_applestore" [href]="environment.iosLink"><img class="img-store"
                                alt="Download on the App Store" src="assets/login/app-store.svg" /></a>
                    </div>
                    <div>
                        <a target="_googleplay" [href]='environment.androidLink'><img class="img-store"
                                alt='Get it on Google Play' src='assets/login/google-play-badge.png' /></a>
                    </div>
                </div>
            </div>

            <div class="social-links">
                <a href="https://instagram.com/csteam.os" target="_instagram" class="fa fa-instagram"></a>
            </div>
        </div>
    </section>

    <footer>
        <div class="container">
            <div style="color: #AC1600; font-weight: 600; margin-bottom: 1rem; font-size: 1.1rem;">Inspiring Future
                Programmers</div>
            <p>&copy; 2025 CSTeam. All rights reserved. Empowering the next generation of computer scientists.</p>
        </div>
    </footer>


</body>